/** @format */
import isPropValid from '@emotion/is-prop-valid';
import { useTranslation } from 'next-i18next';
import React, { FunctionComponent } from 'react';
import styled from 'styled-components';

import CrossIcon from '@toucan/client/global/icons/legacy/cross.svg';

import {
    IconButton,
    IconButtonFill,
    IconButtonSize,
} from '@toucan/client/shared/components/icon-button';

import { styles } from './criteria-box.styles';

// eslint-disable-next-line @mpb-com/mpb/require-types-file -- Legacy code: do not use as an example.
export type CriteriaBoxProps = {
    /**
     * The criteria text to display
     */
    label: string;

    criteriaLabel?: string;

    /**
     * Selection ID for test purposes.
     */
    'data-testid'?: string;

    /**
     * Custom className
     */
    className?: string;

    /**
     * Component remove event handler
     */
    onRemove?: () => void;
};

const StyledCriteriaBox = styled('li').withConfig({
    shouldForwardProp: (prop) => isPropValid(prop),
})`
    ${styles}
`;

export const CriteriaBox: FunctionComponent<CriteriaBoxProps> = ({
    label,
    criteriaLabel,
    onRemove,
    ...otherProps
}: CriteriaBoxProps) => {
    const { t } = useTranslation();

    const renderLabel = () => {
        if (!criteriaLabel) {
            return label;
        }
        return t('{{criteriaLabel}}: {{label}}', {
            criteriaLabel,
            label,
        });
    };

    return (
        <StyledCriteriaBox label={label} {...otherProps}>
            {renderLabel()}
            <IconButton
                label={`Remove ${label}`}
                fill={IconButtonFill.HOLLOW}
                border={false}
                onClick={onRemove}
                size={IconButtonSize.SMALL}
            >
                <CrossIcon />
            </IconButton>
        </StyledCriteriaBox>
    );
};
